import React from 'react'
import { Tabs } from 'antd'
import styled from '@emotion/styled'
import { FamiliesClientList } from './FamiliesClientList'
import { FamiliesStatus } from './FamiliesStatus'
import { FamiliesDetailBySegmentation } from './FamiliesDetailBySegmentation'
import { ReportWrapper } from 'Components'

const { TabPane } = Tabs

export const FamiliesActionPlan = ({
  codDistribuidor,
  codObjetivo,
  year,
  fechaDesde,
  fechaHasta,
  codigoEmpleado,
  nivelEmpleado,
  isMensual,
}) => {
  return (
    <Inner>
      <Tabs
        size="small"
        type="card"
        defaultActiveKey="1"
      >
        <TabPane tab="Lista de clientes" key="1">
          <ReportWrapper reportHeight={205}>
            <FamiliesClientList
              codDistribuidor={codDistribuidor}
              codObjetivo={codObjetivo}
              year={year}
              fechaDesde={fechaDesde}
              fechaHasta={fechaHasta}
              codigoEmpleado={codigoEmpleado}
              nivelEmpleado={nivelEmpleado}
              isMensual={isMensual}
            />
          </ReportWrapper>
        </TabPane>
        <TabPane tab="Status" key="2">
          <ReportWrapper reportHeight={205}>
            <FamiliesStatus
              codDistribuidor={codDistribuidor}
              codObjetivo={codObjetivo}
              year={year}
              fechaDesde={fechaDesde}
              fechaHasta={fechaHasta}
              isMensual={isMensual}
            />
          </ReportWrapper>
        </TabPane>
        <TabPane tab="Detalle por segmentación" key="3">
          <ReportWrapper reportHeight={205}>
            <FamiliesDetailBySegmentation
              codDistribuidor={codDistribuidor}
              codObjetivo={codObjetivo}
              year={year}
              fechaDesde={fechaDesde}
              fechaHasta={fechaHasta}
              isMensual={isMensual}
            />
          </ReportWrapper>
        </TabPane>
      </Tabs>
    </Inner>
  )
}

const Inner = styled.div`
  min-width: 776px;
  margin: auto;
  .ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab-active {
    background: #f9faf9;
    border-bottom: 1px solid #f9faf9;
    font-weight: bold;
  }
`

const PlaceholderContent = styled.div`
  padding: 40px;
  text-align: center;
  color: #999;
  font-size: 16px;
`